import { RouteRecordRaw } from 'vue-router';

declare module 'vue-router' {
  interface RouteMeta {
    requiresLogin: boolean,
    headerTitle: string | null
  }
}

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('src/layouts/MainLayout.vue'),
    children: [
      {
        path: '/login',
        name: 'Login',
        component: () => import('pages/account/LoginPage.vue'),
        meta: {
          requiresLogin: false,
          headerTitle: "Login"
        },
      },
      {
        path: '/register',
        name: 'Register',
        component: () => import('pages/account/RegisterPage.vue'),
        meta: {
          requiresLogin: false,
          headerTitle: "Register"
        },
      },
      {
        path: '/account',
        name: 'Account',
        component: () => import('pages/account/AccountPage.vue'),
        meta: {
          requiresLogin: true,
          headerTitle: "Account"
        },
      },
      {
        path: '/settings',
        name: 'Settings',
        component: () => import('pages/account/SettingsPage.vue'),
        meta: {
          requiresLogin: true,
          headerTitle: "Settings"
        },
      },
      {
        path: '/password-forgot',
        name: 'PasswordForgot',
        component: () => import('pages/account/PasswordForgotPage.vue'),
        meta: {
          requiresLogin: false,
          headerTitle: "Forgot Password"
        },
      },
      {
        path: '/password-reset',
        name: 'PasswordReset',
        component: () => import('pages/account/PasswordResetPage.vue'),
        meta: {
          requiresLogin: false,
          headerTitle: "Reset Password"
        },
      },
      {
        path: '/stock',
        name: 'Stock',
        component: () => import('pages/stock/StockPage.vue'),
        meta: {
          requiresLogin: true,
          headerTitle: "Stock Feed"
        },
      },
      {
        path: '',
        name: 'Customers',
        component: () => import('pages/customer/CustomersPage.vue'),
        meta: {
          requiresLogin: true,
          headerTitle: "Home"
        },
      },
      {
        path: '/customer/:id',
        name: 'Customer',
        component: () => import('pages/customer/CustomerPage.vue'),
        meta: {
          requiresLogin: true,
          headerTitle: null
        },
      },
      {
        path: '/quick-quote',
        name: 'QuickQuote',
        component: () => import('pages/customer/QuickQuoteV4Page.vue'),
        meta: {
          requiresLogin: true,
          headerTitle: "Create Quick Quote"
        },
      },
      {
        path: '/quick-quote-v4',
        name: 'QuickQuoteV4',
        component: () => import('pages/customer/QuickQuoteV4Page.vue'),
        meta: {
          requiresLogin: true,
          headerTitle: "Create Quick Quote"
        },
      },
      {
        path: '/new-proposal',
        name: 'NewProposal',
        component: () => import('pages/customer/ProposalPage.vue'),
        meta: {
          requiresLogin: true,
          headerTitle: "Create Proposal"
        }
      },
      {
        path: '/valuations',
        name: 'Valuations',
        component: () => import('pages/valuations/ValuationsPage.vue'),
        meta: {
          requiresLogin: true,
          headerTitle: "Valuations"
        }
      },
      {
        path: '/payments',
        name: 'Payments',
        component: () => import('pages/payments/PaymentsPage.vue'),
        meta: {
          requiresLogin: true,
          headerTitle: "Payments"
        }
      },
      {
        path: '/:catchAll(.*)*',
        component: () => import('pages/customer/CustomersPage.vue'),
      },
    ],
  },
  {
    path: '/pay',
    name: 'Pay',
    component: () => import('pages/payments/PayPage.vue'),
    meta: {
      requiresLogin: false,
      headerTitle: "Pay"
    }
  },
  {
    path: '/pay-complete',
    name: 'PayComplete',
    component: () => import('pages/payments/PayCompletePage.vue'),
    meta: {
      requiresLogin: false,
      headerTitle: "Pay Complete"
    }
  },
  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/customer/CustomersPage.vue'),
  },
];

export default routes;
